$(function () {

    $('.sidebar').on('click', '.cat-more', function (e) {
        e.stopPropagation();
        $(this).hide();
        $('.cloak').removeClass('cloak');
    })

    $('select[name=cat]').on('change', function (e) {
        e.stopPropagation();
        $.post('/ajax/actions.php?a=loadBoxCategory', { id: this.value }, function (data) {

            $('.categoryBoxModal').remove();
            $('.catmodal').removeClass('hide');
            $('select[name=cat] option[value=""]').prop('selected', true)
            $('.catmodal').prepend(data);
            setTimeout(function () {
                $('select[name="cat[]"]').trigger('change');
            }, 100)

        });
    });

    $('body').on('change', 'select[name^=cat]', treeCat);
    $('body').on('click', '.removeSearchModal', function (e) { e.stopPropagation();
        $('select[name=cat] option[value=""]').prop('selected', true);
        $('.categoryBoxModal').remove();
        $('.catmodal').addClass('hide') })

    $('body').on('click', '.search-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($('#boxCategorySearch').length) {

            if ($('#s-number').length && $('#s-number').val()) {
                $('<input type="hidden" />').prop('name', 'q').val($('#s-number').val()).appendTo($('#boxCategorySearch'));
            }
            $('#boxCategorySearch').submit();
            return;
        }

        if ($('#categorySearch').length) {
            // $('#s-category').remove();

            // if ($('#s-number').length && $('#s-number').val()) {
            //     $('<input type="hidden" />').prop('name', 'q').val($('#s-number').val()).appendTo($('#s-number'));
            // }
            $('#categorySearch').submit();
            return;
        }
    });

    function treeCat(e) {
        e.stopPropagation();
        var ti = $(this),
            value = this.value,
            index = $('select[name^=cat]').index(this);

        if (value) {
            ti.parent().nextAll().remove();
            $('.s2').prop('disabled', true).css({ 'opacity': .5 });

            $.post('/ajax/actions.php?a=loadCategory', { id: value }, function (data) {
                if (data) {
                    var licz = $('.categoryBoxModal select').length;
                    $('.inps').append('<span><select class="form-control" name="cat[' + value + ']" ' + (licz < 2 ? 'required' : '') + '></select> <em></em></span>');
                    $('select[name="cat[' + value + ']"]').empty().append(data).removeAttr('disabled');

                    if (licz > 2) {
                        $('.s2').removeAttr('disabled').removeAttr('style');
                    }
                } else {
                    $('.s2').removeAttr('disabled').removeAttr('style');
                }
            });
        } else {
            ti.parent().nextAll().remove();
            $('.s2').prop('disabled', true).css({ 'opacity': .5 });
        }
    }

    
    // initialize bootstrap tooltip
    $(document).ready(function(){
        $('[data-toggle="tooltip"]').tooltip();   
    });



    // cookies
    if(!$.cookie("profijtuitlaat")){
        $(".footer-cookies").show();
    }
    $("#cookie").click(function() {
        $.cookie("profijtuitlaat", 1);   
        $(".footer-cookies").fadeOut( "" );  
    });
    $("#cookie-xs").click(function() {
        $.cookie("profijtuitlaat", 1);   
        $(".footer-cookies").fadeOut( "" ); 
    });

});